import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { DocumentoElectronicoService } from 'src/app/services/documento-electronico.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { EmpresasRecibidosModalObservacionesComponent } from '../modal-observaciones/modal-observaciones.component';

export interface IInputParams {
  desde: Date
  hasta: Date
  tipo_dte_codigo: number
  statusDocumento: number
}
@Component({
  selector: 'app-empresas-recibidos-table-intercambio-sii',
  templateUrl: './table-intercambio-sii.component.html',
  styleUrls: ['../empresas-recibidos.component.scss'],
  providers: [SecurityService]
})
export class EmpresasRecibidosTableIntercambioSIIComponent implements OnInit {

  @Input() visible: boolean = false
  @ViewChild(EmpresasRecibidosModalObservacionesComponent, { static: true }) observacionesModal: EmpresasRecibidosModalObservacionesComponent
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent

  // Data & Tmp
  rutEmpresa: number
  sucursalCodigo: number
  loading: boolean = false
  listaDocumentos: Array<any> = null
  paginationContext: PaginationContext = new PaginationContext()

  params: IInputParams = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private documentoElectronicoService: DocumentoElectronicoService,
    public rutService: RutService
  ) {
    this.log = this.clog.log('EMPRESAS-RECIBIDOS / INTERCAMBIO-EMPRESAS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 10
  }

  loadAndShow(params: IInputParams): boolean {
    try {
      this.params = params
      this.buscar(1)
      return true
    } catch { return false }
  }

  buscar(pageNumber: number = 1) {
    this.listaDocumentos = []
    this.loading = true

    this.paginationContext.CurrentPage = pageNumber

    const { desde, hasta, tipo_dte_codigo, statusDocumento } = this.params
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      desde,
      hasta,
      tipo_dte_codigo,
      statusDocumento : statusDocumento ? statusDocumento : 0,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.log('inputParams', JSON.stringify(inputParams))
    this.documentoElectronicoService.obtenerRecibidosIntercambioSII(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaDocumentos = registros

      this.listaDocumentos.forEach((doc, index) => {
        this.setDocAdditionalData(doc, index)
      })

      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  setDocAdditionalData(doc, index: number) {
    doc.rutFormato = this.rutService.AgregarDV(doc.rut)
    doc.index = index

    doc.showAROptions = false
    doc.showAcSendButton = false
    doc.ARLoading = false

    doc.showRecMercOptions = false
    doc.showRecMercSendButton = false
    doc.RecMercLoading = false

    doc.showRespComOptions = false
    doc.showRespComSendButton = false
    doc.RespComLoading = false

    if (doc.acuse_recibo === null) {
      doc.showAROptions = true
      doc.showAcSendButton = true
      doc.showRecMercOptions = false
      doc.showRespComOptions = false
    } else {
      doc.showAROptions = true
      doc.showAcSendButton = doc.acuse_recibo === null

      if (doc.acuse_recibo === true) {
        doc.showRecMercOptions = true
        doc.showRespComOptions = true

        doc.showRecMercSendButton = doc.recepcion_mercaderia === null
        doc.showRespComSendButton = doc.respuesta_comercial === null

        if (doc.recepcion_mercaderia == false) {
          doc.showRespComOptions = false
        }

        if (doc.respuesta_comercial !== null) {
          doc.showRecMercSendButton = false
        }
      }
    }
  }

  reSend({ id_lsoft, index }) {
    this.modalConfirm.showWithInlineConfig("Confirmar solicitud", "¿Desea solicitar envío de acuse de recibo?", () => {

      const doc = this.listaDocumentos.filter(p => p.index === index)[0]
      doc.ARLoading = true

      this.documentoElectronicoService.enviarRecibidoAcuseRecibo({
        empresa_rut: this.rutEmpresa,
        id_lsoft,
        type: 2
      }, ({ mensajes, respuesta }) => {
        doc.ARLoading = false

        const ok = respuesta !== null && respuesta !== undefined
        if (!ok) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        if (!respuesta) {
          this.toastService.error('No se pudo enviar el email')
          return
        }

        this.toastService.success('Email enviado')
        this.buscar(this.paginationContext.CurrentPage);
      })
    })
  }

  showModalObservaciones(type: 'RECEP_MERCADERIA' | 'RTA_COMERCIAL', { id_lsoft, index }) {
    switch (type) {
      case 'RECEP_MERCADERIA':
        this.observacionesModal.show({ acceptCallback: this.EnvioAsignacionDocumentoRecepcionMercaderia, additionalData: { id_lsoft, index } })
        break
      case 'RTA_COMERCIAL':
        this.observacionesModal.show({ acceptCallback: this.EnvioAsignacionDocumentoRespuestaComercial, additionalData: { id_lsoft, index } })
        break
      default:
        return
    }
  }

  EnvioAsignacionDocumentoRecepcionMercaderia = (aprobado: boolean, observacion: string, additionalData: any) => {
    const { id_lsoft, index } = additionalData

    const doc = this.listaDocumentos.filter(p => p.index === index)[0]
    doc.RecMercLoading = true

    this.documentoElectronicoService.enviarRecibidoRecepcionMercaderia({
      empresa_rut: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
      id_lsoft,
    }, ({ mensajes, respuesta }) => {
      doc.RecMercLoading = false

      const ok = respuesta !== null && respuesta !== undefined
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      if (!respuesta) {
        this.toastService.error('No se pudo enviar la solicitud')
        return
      }

      doc.recepcion_mercaderia = aprobado
      this.setDocAdditionalData(doc, index)
      this.toastService.success('Solicitud enviada')
      // this.buscar(this.paginationContext.CurrentPage);
    })
  }

  EnvioAsignacionDocumentoRespuestaComercial = (aprobado: boolean, observacion: string, additionalData: any) => {
    const { id_lsoft, index } = additionalData

    const doc = this.listaDocumentos.filter(p => p.index === index)[0]
    doc.RespComLoading = true

    this.documentoElectronicoService.enviarRecibidoRespuestaComercial({
      empresa_rut: this.rutEmpresa,
      id_lsoft,
      result: 2, // TODO: Está consumiendo el mismo EP que para Intercambio-Empresas. Se debe validar y ajustar.
      observacion,
      type: 2
    }, ({ mensajes, respuesta }) => {
      doc.RespComLoading = false

      const ok = respuesta !== null && respuesta !== undefined
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      if (!respuesta) {
        this.toastService.error('No se pudo enviar la solicitud')
        return
      }

      doc.respuesta_comercial = aprobado
      this.setDocAdditionalData(doc, index)
      this.toastService.success('Solicitud enviada')
      // this.buscar(this.paginationContext.CurrentPage);
    })
  }

}
